<div [formGroup]="form" class="query-filter">
  <!-- objectName  -->
  <mat-form-field class="full-width">
    <mat-select
      formControlName="objectName"
      required
      (valueChange)="onObjectNameChange()"
      [placeholder]="'AUTOMATOR.getObjectAction.form.filtration.objectName.placeholder' | translate"
    >
      @for (objectType of relationalObjectNames$ | async; track objectType.id) {
        <mat-option [value]="objectType.id">
          {{ 'AUTOMATOR.' + objectType.translationKey | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- objectField  -->
  @if (form.get('objectName')?.value) {
    <mat-form-field class="full-width">
      <mat-select
        formControlName="objectField"
        required
        (valueChange)="onObjectFieldChange($event)"
        [placeholder]="
          'AUTOMATOR.getObjectAction.form.filtration.objectField.placeholder' | translate
        "
      >
        @for (objectField of filtrationObjectFields; track objectField.name) {
          <mat-option [value]="objectField.name">
            {{ objectField.isCustomField ? objectField.label : (objectField.label | translate) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <!-- operator -->
  @if (form.get('objectField')?.value) {
    <mat-form-field class="full-width">
      <mat-label translate>AUTOMATOR.LocalChoiceFlow.form.operator.placeholder</mat-label>
      <mat-select (valueChange)="onOperatorChange($event)" formControlName="operator" required>
        @for (operator of filterOperators$ | async; track operator.value) {
          <mat-option [value]="operator.value">
            {{ operator.label | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <!-- value  -->
  @if (isValueInputVisible()) {
    <app-configuration-field-control
      formControlName="value"
      [required]="true"
      [formSubmitted]="formSubmitted"
      [valueControlTemplate]="
        fieldKind === 'OBJECT' ? objectIdValueControlTemplate : valueControlTemplate
      "
      [placeholder]="'AUTOMATOR.configurationFieldControl.variable' | translate"
      [variables]="mapToWorkflowElementVariableView(availableDynamicVariables)"
    >
    </app-configuration-field-control>
  }
</div>
<ng-template let-control let-placeholder="placeholder" #valueControlTemplate>
  @if (selectedObjectField) {
    <app-universal-form-control
      [required]="true"
      [formSubmitted]="formSubmitted"
      [formControl]="control"
      [placeholder]="placeholder"
      [fieldKind]="selectedObjectField.kind"
      [isCustomField]="selectedObjectField.isCustomField || false"
      [enumValues]="getEnumValues()"
    >
    </app-universal-form-control>
  }
</ng-template>

<ng-template #objectIdValueControlTemplate let-control let-placeholder="placeholder">
  <mat-form-field class="full-width">
    <app-table-input
      [required]="true"
      [filterObjectName]="getFilterObjectName()"
      [formControl]="control"
      [placeholder]="placeholder"
      [valueTemplate]="objectTemplate"
    >
    </app-table-input>
  </mat-form-field>
</ng-template>

<ng-template let-id let-onRemove="onRemove" let-objectName="objectName" #objectTemplate>
  <app-object-label [objectName]="objectName" [objectId]="id" (remove)="onRemove()">
  </app-object-label>
</ng-template>
